import Record from 'dataclass'
import {DCategoriaDePermissao, DRegraDeNotificacao, DTipoObservado, EmpregadoId, EventoObservavel, GrupoId, LocalDeTrabalhoId, TipoDeNotificacao, TipoNotificado, UsuarioId} from '@/tipos/RegrasDeNotificacao'
import { required, minLength, numeric } from 'vuelidate/lib/validators'
import { RuleDecl } from 'vue/types/options'

export class RegraDeNotificacaoInvalida extends Record<Error> {
  message = 'Não será possível criar a regra, pois a mesma não preenche os requisitos.'
}

export class RegraDeNotificacaoInexistente extends Record<RegraDeNotificacaoInvalida> {
  message = 'Não foi possível carregar a regra para edição, você será redirecionado para a tela de listagem.'
}

export class TipoObservadoNaoEhValido extends Record<RegraDeNotificacaoInvalida> {
  message = 'O tipo observado informado não é válido.'
}

export class CategoriaDePermissaoNaoEhValido extends Record<RegraDeNotificacaoInvalida> {
  message = 'A categoria de permissão selecionada não é válida.'
}

export class TipoObservado extends Record<DTipoObservado> {
  static tiposValidos = ['funcionarios', 'locais_de_trabalho', 'grupos'] as DTipoObservado[]

  static from (tipo?: string): DTipoObservado {
    const itemEhValido: boolean = typeof tipo === 'string' && tipo in TipoObservado.tiposValidos

    if (itemEhValido) {
      return tipo as unknown as DTipoObservado
    }
    throw new TipoObservadoNaoEhValido()
  }
}

export class CategoriaDePermissao extends Record<DCategoriaDePermissao> {
  static categoriasValidas = ['gestor', 'empregado'] as DCategoriaDePermissao[]

  static from (categoria?: string): DCategoriaDePermissao {
    const itemEhValido: boolean = typeof categoria === 'string' && categoria in CategoriaDePermissao.categoriasValidas

    if (itemEhValido) {
      return categoria as unknown as DCategoriaDePermissao
    }
    throw new CategoriaDePermissaoNaoEhValido()
  }
}

export class RegraDeNotificacao extends Record<DRegraDeNotificacao> {
  id?: string;
  categoria: DCategoriaDePermissao = 'gestor';
  nome = '';
  ativa = true;
  codigo = '';
  tipoNotificado: TipoNotificado = 'usuarios';
  tipoObservado: DTipoObservado = 'funcionarios';
  usuariosNotificados: UsuarioId[] = [];
  tiposDeNotificacao: TipoDeNotificacao[] = [];
  locaisDeTrabalhoObservados: LocalDeTrabalhoId[] = [];
  gruposDeUsuarioObservados: GrupoId[] = [];
  funcionariosObservados: EmpregadoId[] = [];
  eventosObservados: EventoObservavel[] = [];

  static validacoes: RuleDecl = {
    usuariosNotificados: {
      value: {
        required,
        minLength: minLength(1),
        $each: {
          required,
          minLength: minLength(24)
        }
      }
    },
    tipoNotificado: {
      value: {
        required
      }
    },
    nome: {
      value: {
        required
      }
    },
    codigo: {
      value: {
        required,
        numeric,
        minLength: minLength(4)
      }
    },
    notificacaoVia: {
      value: {
        required,
        minLength: minLength(1)
      }
    },
    eventosObservados: {
      value: {
        required,
        minLength: minLength(1)
      }
    },
    tipoObservado: {
      value: {
        required
      }
    },
    sobreQuemSeraObservado: {
      value: {
        required,
        minLength: minLength(1)
      }
    }
  }

  static from (data: DRegraDeNotificacao): RegraDeNotificacao {
    // RegraDeNotificacao.camposObrigatorios.forEach((campo: string) => {
    //   const naoPossuiChave = !data.hasOwnProperty(campo)
    //   const valorNaoEhValido = !!campo
    //   if (naoPossuiChave || valorNaoEhValido) {
    //     throw new RegraDeNotificacaoInvalida()
    //   }
    // })

    // const id: string = data.id as string
    // const nome: string = data.nome.toString()
    // const codigo: string = data.codigo.toString()
    // const tipoObservado: DTipoObservado = TipoObservado.from(data.tipoObservado)

    return new RegraDeNotificacao({ ...data })
  }

  static criarRegraParaCadaNotificado (regra: DRegraDeNotificacao): RegraDeNotificacao[] {
    const regraParaCadaNotificado = regra.usuariosNotificados.map((usuario: string) => {
      const codigoNovo = `${regra.codigo}${usuario.replace(/\D/g, '').slice(0, 7)}`
      return new RegraDeNotificacao({ ...regra, usuariosNotificados: [usuario], codigo: codigoNovo })
    })

    return regraParaCadaNotificado
  }

  // toJSON (): DRegraDeNotificacao {
  //   return {
  //     id: this.id,
  //     categoria: this.categoria,
  //     nome: this.nome,
  //     ativa: this.ativa,
  //     codigo: this.codigo,
  //     tipoNotificado: this.tipoNotificado,
  //     tipoObservado: this.tipoObservado,
  //     usuariosNotificados: this.usuariosNotificados,
  //     tiposDeNotificacao: this.tiposDeNotificacao,
  //     locaisDeTrabalhoObservados: this.locaisDeTrabalhoObservados,
  //     gruposDeUsuarioObservados: this.gruposDeUsuarioObservados,
  //     funcionariosObservados: this.funcionariosObservados,
  //     eventosObservados: this.eventosObservados
  //   }
  // }

  toString (): string {
    const {nome, codigo} = this
    return `<${nome} ${codigo}>`
  }

  // equals (outraRegra: DRegraDeNotificacao): boolean {
  //   const categoriasSaoIguais = this.categoria === outraRegra.categoria
  //   const estadosSaoIguais = this.ativa === outraRegra.ativa
  //   const codigosSaoIguais = this.codigo === outraRegra.codigo
  //   const tiposObservadosSaoIguais = this.tipoObservado === outraRegra.tipoObservado
  //   return categoriasSaoIguais && estadosSaoIguais && codigosSaoIguais && tiposObservadosSaoIguais
  // }
}
